import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "rows"]

  connect() {
    this.timeout = null
  }

  filter() {
    // Cancelar el timeout anterior si existe
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Esperar 300ms después de que el usuario deje de escribir
    this.timeout = setTimeout(() => {
      this.performFilter()
    }, 300)
  }

  performFilter() {
    const filterValue = this.inputTarget.value.toLowerCase()
    const rows = this.rowsTarget.querySelectorAll('tr[data-aliance-table-search-target="row"]')
    
    rows.forEach(row => {
      const rowText = Array.from(row.cells).map(cell => cell.textContent.trim()).join(' ').toLowerCase()
      const shouldShow = rowText.includes(filterValue)
      row.style.display = shouldShow ? "" : "none"
    })
  }
}

